import React from "react";

const SignUp = () => {
  return (
    <>
      <h1>Work in Progress</h1>
    </>
  );
};

export default SignUp;
